import { sendStats } from "./stats";
import { project } from "./initializeStats";
import { scrollToEvent } from "./helpers";

export const anchors = function () {
  let initSlug =
    document.location.hash ||
    document.location.pathname.split("/").pop() ||
    document.querySelectorAll(".__js_stats_wrapper")[0].getAttribute("id");
  if (initSlug.startsWith("#")) {
    initSlug = initSlug.slice(1);
  }
  project.activeSlug = initSlug;
  const customOffset = document
    .querySelector(".header")
    .getBoundingClientRect().height;
  // const customOffset = parseInt(getComputedStyle(document.documentElement)
  //   .getPropertyValue('--header-height'));
  const sections = document.querySelectorAll(".__js_stats_wrapper");
  let wp_content_selector;
  const animationTime = 800;
  let sectionScrollCheckTS = null;
  let reportSlugTS = -1;

  const reportSlug = function () {
    if (project.lastReportedSlug === null) {
      // wyślij statystykę pageview standard
      if (project.activeSlug && statData[project.activeSlug]) {
        wp_dot_addparams.ctags = statData[project.activeSlug].tags;
        WP.push(() => {
          window.dataLayer.push({
            event: "pageview",
            page: {
              pageviewType: "standard",
              error404: basicStatData.ga.page.error404,
              templateType: "AS",
            },
            site: {
              name: basicStatData.ga.site.name,
              version: basicStatData.ga.site.version,
              cms: basicStatData.ga.site.cms,
              as: {
                orderId: asorderid,
                productName: asproduct,
                name: asname,
              },
            },
            content: {
              title: statData[project.activeSlug].title,
              category: {
                IAB: statData[project.activeSlug].category.IAB,
                Gemius: statData[project.activeSlug].category.Gemius,
              },
              tags: statData[project.activeSlug].tags,
            },
          });
        });
      }
    } else {
      // wyślij statystykę pageview scrolboost vpv. pageviewType ma wartość "overlay"
      // gdy nie mamy doładowania i "scrollboost" gdy następuje doładowanie, ALE dla pseudo dynamicznych stron AS ma byc jednak scrollboost ;) - ustalone z Salestube !
      wp_content_selector = document.getElementById(project.lastReportedSlug);

      project.unloadData(project.lastReportedSlug);

      if (project.activeSlug && statData[project.activeSlug]) {
        wp_dot_addparams.ctags = statData[project.activeSlug].tags;
        WP.push(() => {
          window.dataLayer.push({
            event: "pageviewVpv",
            page: {
              pageviewType: "scrollboost",
              error404: basicStatData.ga.page.error404,
              templateType: "AS",
            },
            site: {
              name: basicStatData.ga.site.name,
              version: basicStatData.ga.site.version,
              cms: basicStatData.ga.site.cms,
              as: {
                orderId: asorderid,
                productName: asproduct,
                name: asname,
              },
              frontendPlatform: "other",
            },
            content: {
              title: statData[project.activeSlug].title,
              category: {
                IAB: statData[project.activeSlug].category.IAB,
                Gemius: statData[project.activeSlug].category.Gemius,
              },
              tags: statData[project.activeSlug].tags,
            },
          });
        });
      }
    }

    project.lastReportedSlug = project.activeSlug;
    reportSlugTS = -1;
  };

  const changeActiveSlug = function (slug) {
    project.activeSlug = slug;
    document
      .querySelectorAll(".header__nav li a")
      .forEach((el) => el.classList.remove("__active"));
    if (document.querySelector(`.header__nav [data-slug="${slug}"]`)) {
      document
        .querySelector(`.header__nav [data-slug="${slug}"]`)
        .classList.add("__active");
    }

    if (project.lastReportedSlug === null) {
      // jeżeli pierwsze wejście to wysyłaj pageview od razu
      reportSlug();
    } else if (project.lastReportedSlug !== slug) {
      // jeżeli zmiana sluga to wysyłaj po sekundzie statystykę

      if (reportSlugTS > -1) clearTimeout(reportSlugTS);
      reportSlugTS = setTimeout(reportSlug, 1000);
    } else if (reportSlugTS > -1) clearTimeout(reportSlugTS);
  };

  /* Sprawdzanie czy user zescrollował do sekcji. Jeżeli tak to ustawia pozycję w nawigacji */
  const sectionScrollCheck = function () {
    sectionScrollCheckTS = setTimeout(sectionScrollCheck, 200);

    const topScroll =
      document.querySelector("body").getBoundingClientRect().top === 0
        ? 0
        : -document.querySelector("body").getBoundingClientRect().top;

    // wymuszenie strony głównej
    if (
      topScroll <= customOffset &&
      document.location.pathname.split("/").pop().length < 1
    ) {
      changeActiveSlug(sections[0].getAttribute("id"));
      return;
    }

    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      const sectionOffset = section.offsetTop;
      const sectionHeight = section.getBoundingClientRect().height;
      if (
        project.activeSlug !== section.getAttribute("id") &&
        topScroll > sectionOffset - customOffset - 10 &&
        topScroll < sectionOffset + sectionHeight - customOffset - 10
      ) {
        changeActiveSlug(section.getAttribute("id"));
        break;
      }
    }
  };

  /* Inicjalizacja metod dla obsługi nawigacji - clików i sprawdzanie scrolla */
  const initNavigation = function () {
    sectionScrollCheckTS = setTimeout(sectionScrollCheck, animationTime + 25);

    document.querySelectorAll("[data-slug]").forEach((el) => {
      el.addEventListener("click", (e) => {
        // console.log('click');
        if (sectionScrollCheckTS) clearTimeout(sectionScrollCheckTS);

        e.preventDefault();
        let slug = el.getAttribute("data-slug");
        if (!slug.length) slug = "/";

        changeActiveSlug(slug);
        project.isScrollingController(true);
        scrollToEvent(
          document.getElementById(slug).getBoundingClientRect().top +
            window.scrollY -
            customOffset,
          () => {
            project.isScrollingController(false);
          }
        );
        sectionScrollCheckTS = setTimeout(
          sectionScrollCheck,
          animationTime + 25
        );
      });
    });
  };

  const scrollOnStart = function () {
    if (document.getElementById(initSlug)) {
      if (!(document.location.hash && document.location.hash === "#kontakt")) {
        project.isScrollingController(true);
        scrollToEvent(
          document.getElementById(initSlug).getBoundingClientRect().top +
            window.scrollY -
            customOffset,
          () => {
            project.isScrollingController(false);
          }
        );
      }
    }

    sendStats("progress", "start", initSlug);

    changeActiveSlug(initSlug);
    initNavigation();
  };

  if (initSlug.length > 1) {
    setTimeout(scrollOnStart, 600);
  }
};
